import { ApiResponseType } from './api';

export type ClaimedCandidateGlobalRequestType = {
    Start: number;
    Limit: number;
    'SearchParam.FilterValue'?: string;
    'SearchParam.SortType'?: number;
};

export type DecyptedClaimedCandidateGlobalType = {
    Active: boolean;
    CandidateLocation: string;
    CityDistrict: string;
    Country: string;
    Dob: Date | string;
    Email: string;
    FirstName: string;
    Gender: number;
    Id: string;
    IsUser: number;
    JobTitle: string;
    LastName: string;
    MiddleName: null;
    Phone: string;
    State: string;
};

export type ClaimedCandidateAdvanceSearchRequestType = {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
};

export enum CompanyStatus {
    Joined,
    Uploaded,
    VerificationPending,
    Deleted,
}

export enum CandidateStatus {
    Joined = 0,
    Uploaded = 1,
    Pending = 2,
    Deleted = 3,
    Invited = 4,
    ProvisionallyJoined = 5,
}

export enum CompanyType {
    Default,
    ViaExcel,
}

export enum CandidateType {
    Default = 0,
    ViaExcel = 1,
    ViaHRMS = 2,
    ViaDataPunch = 3,
    ViaScreenX = 4,
}

export type ClaimedExternalSeachResultType = { base: string; hash: string };

export type ClaimedCandidateGlobalResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: ClaimedExternalSeachResultType[];
};

export type ClaimedCandidateAdvanceSearchResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: any;
};
